/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiBarberShiftIdQueryResponse, GetApiBarberShiftIdPathParams, GetApiBarberShiftId400, GetApiBarberShiftId401, GetApiBarberShiftId403, GetApiBarberShiftId404, GetApiBarberShiftId500 } from "../entities/GetApiBarberShiftId";

function getGetApiBarberShiftIdUrl(id: GetApiBarberShiftIdPathParams["id"]) {
  const res = { method: 'GET', url: `/api/barber/shift/${id}` as const }
  return res
}

/**
 * @description Получить детали смены мастера
 * @summary Получить смену
 * {@link /api/barber/shift/:id}
 */
export async function getApiBarberShiftId(id: GetApiBarberShiftIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiBarberShiftIdQueryResponse, ResponseErrorConfig<GetApiBarberShiftId400 | GetApiBarberShiftId401 | GetApiBarberShiftId403 | GetApiBarberShiftId404 | GetApiBarberShiftId500>, unknown>({ method : "GET", url : getGetApiBarberShiftIdUrl(id).url.toString(), ... requestConfig })
  return res.data
}